/**
 * @generated SignedSource<<53d8ea27e442f86270155d6ad6d28ce8>>
 * 
 * @lightSyntaxTransform
 *//* eslint-disable */'use strict';/*::
import type { ConcreteRequest, Query } from 'relay-runtime';
export type AppAssetListStorage$variables = {||};
export type AppAssetListStorage$data = {|
  +internalAppAssetStorage: {|
    +hasBucket: boolean,
  |},
|};
export type AppAssetListStorage = {|
  response: AppAssetListStorage$data,
  variables: AppAssetListStorage$variables,
|};
*/var node/*: ConcreteRequest*/=function(){var v0=[{"alias":null,"args":null,"concreteType":"GraphQLInternalAppAssetStorage","kind":"LinkedField","name":"internalAppAssetStorage","plural":false,"selections":[{"alias":null,"args":null,"kind":"ScalarField","name":"hasBucket","storageKey":null}],"storageKey":null}];return{"fragment":{"argumentDefinitions":[],"kind":"Fragment","metadata":null,"name":"AppAssetListStorage","selections":v0/*:: as any*/,"type":"Query","abstractKey":null},"kind":"Request","operation":{"argumentDefinitions":[],"kind":"Operation","name":"AppAssetListStorage","selections":v0/*:: as any*/},"params":{"cacheID":"2cc7682ed132e5be252d603f0fc0f22d","id":null,"metadata":{},"name":"AppAssetListStorage","operationKind":"query","text":"query AppAssetListStorage {\n  internalAppAssetStorage {\n    hasBucket\n  }\n}\n"}};}();node/*:: as any*/.hash="68fb61967cd8ad39982aaae98e72a3fc";export default node/*:: as any*//*:: as Query<
  AppAssetListStorage$variables,
  AppAssetListStorage$data,
>*/;